import React from 'react';
import bg from '../../../assets/images/yzqf/grscbg.jpg';
import { glpdata } from './data';
import Glpitem from './Glpitem';
function GRSC({ setType }) {
  return (
    <div className="common-page animate__animated animate__fadeIn">
      <img src={bg} alt="" />
      <div className="xsyjitembox grscitembox">
        {glpdata.grsc.map((item, index) => {
          return (
            <Glpitem item={item} index={index} cls="xsyjitem1" key={index} />
          );
        })}
      </div>
      <div
        className="back"
        onClick={() => {
          setType('');
        }}></div>
    </div>
  );
}

export default GRSC;
